<ion-content>

    <custom-header [class]="themeConfig.name"></custom-header>

    <ion-refresher (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <ion-backdrop *ngIf="showSharing"
                  (ionBackdropTap)="hideSharing()">
    </ion-backdrop>

    <div *ngIf="!loading"
         class="content-box">

        <ion-row class="ion-no-padding ion-align-items-center">
            <ion-col size="12">
                <h1 [innerHTML]="'CREDENTIAL_WALLET_PAGE_TITLE_PUBLIC' | trns : {name: participant.getFullName()}"></h1>
            </ion-col>
        </ion-row>

        <div class="content-box-inner">
            <div class="content-data">
                <div class="credentials-list">
                    <ng-container *ngIf="credentials.length > 0">
                        <div *ngFor="let credential of credentials"
                             class="item">
                            <div class="image"
                                 (click)="openPublicDetail(credential)">
                                <img *ngIf="credential.certification_preview"
                                     [src]="plt.createSignedLink(credential.certification_preview, true)"
                                     [alt]="credential.certification_name" />
                                <img *ngIf="credential.certification_badge"
                                     [src]="plt.createSignedLink(credential.certification_badge, true)"
                                     [ngClass]="{'badge': !!credential.certification_preview}"
                                     [alt]="credential.certification_name" />
                            </div>
                            <div class="details">
                                <strong>{{credential.certification_name}}</strong>
                                <span class="date">{{credential.issued_on | datex: 'dateFormatDefault'}}</span>
                                <strong>{{credential.certification_issuer}}</strong>
                                <span class="bitcoin">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/bitcoin.svg"
                                              class="fill-menu-contrast">
                                    </svg-icon>
                                    {{'CREDENTIAL_WALLET_BLOCKCHAIN_ID'| translate}}
                                    <strong *ngIf="credential.blockchain_id">{{credential.blockchain_id}}</strong>
                                    <strong *ngIf="!credential.blockchain_id"
                                            class="help"
                                            [title]="'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING_HELP' | trns">
                                        <span title="">{{'CREDENTIAL_WALLET_BLOCKCHAIN_ID_PENDING'| translate}}</span>
                                    </strong>
                                </span>
                            </div>
                        </div>

                        <ng-container *ngFor="let i of countSizes[3]; let c = index">
                            <ng-container *ngIf="c < (3 - (credentials.length % 3)) && credentials.length % 3 != 0">
                                <div class="item-empty"></div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="credentials.length == 0">
                        <div class="empty-data">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-credentials-wallet.svg"
                                      class="icon fill-light">
                            </svg-icon>
                            <h3>
                                {{ 'CREDENTIAL_WALLET_EMPTY' | trns }}
                            </h3>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="loading"
         class="content-centered-column">
        <div class="content-centered-row loading">
            <ion-spinner></ion-spinner>
            <h2>{{ 'CREDENTIAL_WALLET_PREPARING' | trns }}</h2>
        </div>
    </div>

    <custom-footer></custom-footer>
</ion-content>